<div *ngIf="componentInitializedFully">

    <div class="new-credit-card-header">
        <div class="new-credit-card-header-inner">
            <div class="header-left">
                <h1 class="page-name">{{ headerTitle }}</h1>
                <div class="page-description" [innerHTML]="headerSubtitle"></div>
            </div>
        </div>
    </div>

    <div id="mainContainer" *ngIf="!showSuccess && !billingDetailsFailedToLoad">
        <form id="creditCardForm" [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form">
            <div class="new-credit-card-main new-credit-card-main-top-header">
                <div class="new-credit-card-main-inner">
                    <div class="new-credit-card-main-left">
                        <div class="mb-4">
                            <div class="header-block">
                                <div class="header-block__header">Cardholder Details</div>
                                <div class="header-block__desc">
                                    <span class="info_important">*</span>Name and phone number must match the name on the credit card
                                </div>
                            </div>

                            <!-- First Name -->
                            <div class="mt-4 border-container form-field-container">
                                <span class="border-text" [ngClass]="{ 'hide-label': !formControls.firstName.value, 'show-label': formControls.firstName.value }">First Name</span>
                                <input
                                    type="text"
                                    id="firstName"
                                    [formControl]="formControls.firstName"
                                    [maxlength]="maxLengths.Name"
                                    class="form-control"
                                    placeholder="First Name">
                                <span class="text-danger" *ngIf="formControls.firstName.invalid && showFormErrors">
                                    First name is required
                                </span>
                            </div>

                            <!-- Last Name -->
                            <div class="mt-4 border-container form-field-container">
                                <span class="border-text" [ngClass]="{ 'hide-label': !formControls.firstName.value, 'show-label': formControls.firstName.value }">Last Name</span>
                                <input
                                    type="text"
                                    id="lastName"
                                    [formControl]="formControls.lastName"
                                    [maxlength]="maxLengths.Name"
                                    class="form-control"
                                    placeholder="Last Name">
                                <span class="text-danger" *ngIf="formControls.lastName.invalid && showFormErrors">
                                    Last name is too long
                                </span>
                            </div>

                            <!-- Email -->
                            <div class="mt-4 border-container form-field-container">
                                <span class="border-text" [ngClass]="{ 'hide-label': !formControls.email.value, 'show-label': formControls.email.value }">Email</span>
                                <input
                                    type="email"
                                    id="email"
                                    [formControl]="formControls.email"
                                    [maxlength]="maxLengths.Email"
                                    class="form-control"
                                    placeholder="Email">
                                <span class="text-danger" *ngIf="formControls.email.invalid && (formControls.email.dirty || formControls.email.touched || showFormErrors)">
                                    <ng-container *ngIf="formControls.email.errors?.['required'] && showFormErrors">Email is required</ng-container>
                                    <ng-container *ngIf="formControls.email.errors?.['email']">Please enter a valid email address.</ng-container>
                                </span>
                            </div>

                            <!-- Phone -->
                            <div class="mt-4 border-container form-field-container">
                                <span class="border-text" [ngClass]="{ 'hide-label': !formControls.phone.value, 'show-label': formControls.phone.value }">Phone</span>
                                <input
                                    type="tel"
                                    id="phone"
                                    [formControl]="formControls.phone"
                                    [maxlength]="maxLengths.Phone"
                                    class="form-control"
                                    placeholder="Phone">
                                <span class="text-danger" *ngIf="formControls.phone.invalid && showFormErrors">
                                    Phone is required
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="new-credit-card-main-right">
                        <div class="mb-4">
                            <div class="header-block">
                                <div class="header-block__header">Billing Address</div>
                                <div class="header-block__desc"><span class="info_important">*</span>This address must match the billing address
                                    for your credit card otherwise we will not be able to process your order.
                                </div>
                            </div>

                            <div id="newCreditCardMyAddressContainer">
                                <!-- Address -->
                                <div class="mt-4 border-container form-field-container">
                                    <span class="border-text" [ngClass]="{ 'hide-label': !formControls.address.value, 'show-label': formControls.address.value }">Billing Address</span>
                                    <input
                                        type="text"
                                        id="address"
                                        [formControl]="formControls.address"
                                        [maxlength]="maxLengths.Address"
                                        class="form-control"
                                        placeholder="Billing Address">
                                    <span class="text-danger" *ngIf="formControls.address.invalid && showFormErrors">
                                        Billing address is required
                                    </span>
                                </div>

                                <!-- City -->
                                <div class="mt-4 border-container form-field-container">
                                    <span class="border-text" [ngClass]="{ 'hide-label': !formControls.city.value, 'show-label': formControls.city.value }">City</span>
                                    <input
                                        type="text"
                                        id="city"
                                        [formControl]="formControls.city"
                                        [maxlength]="maxLengths.City"
                                        class="form-control"
                                        placeholder="City">
                                    <span class="text-danger" *ngIf="formControls.city.invalid && showFormErrors">
                                        City is required
                                    </span>
                                </div>

                                <!-- State/Province -->
                                <div class="mt-4 border-container form-field-container">
                                    <span class="border-text" [ngClass]="{ 'hide-label': !formControls.state.value, 'show-label': formControls.state.value }">State/Province (two letter code)</span>
                                    <input
                                        type="text"
                                        id="state"
                                        [formControl]="formControls.state"
                                        maxlength="2"
                                        class="form-control text-uppercase"
                                        placeholder="State/Province (two letter code)"
                                        (input)="onStateInput($event)">
                                    <span class="text-danger" *ngIf="formControls.state.invalid && showFormErrors">
                                        Enter a 2-letter state/province code
                                    </span>
                                </div>

                                <!-- Zip/Postal Code -->
                                <div class="mt-4 border-container form-field-container">
                                    <span class="border-text" [ngClass]="{ 'hide-label': !formControls.postalCode.value, 'show-label': formControls.postalCode.value }">Zip/Postal Code</span>
                                    <input
                                        type="text"
                                        id="zip"
                                        [formControl]="formControls.postalCode"
                                        [maxlength]="maxLengths.PostalCode"
                                        class="form-control"
                                        placeholder="Zip/Postal Code">
                                    <span class="text-danger" *ngIf="formControls.postalCode.invalid && showFormErrors">
                                        Zip/Postal code is required
                                    </span>
                                </div>

                                <!-- Country -->
                                <div class="mt-4 border-container form-field-container">
                                    <span class="border-text" [ngClass]="{ 'hide-label': !formControls.country.value, 'show-label': formControls.country.value }">Country</span>
                                    <select
                                        id="country"
                                        [formControl]="formControls.country"
                                        class="form-control"
                                    >
                                        <option *ngFor="let country of validCountriesList" [value]="country.countryCode">
                                            {{country.countryName}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="credit-card-info">
                        <div class="mb-4">
                            <!-- Credit card information -->
                            <div class="header-block">
                                <div class="header-block__header">Credit card information</div>
                                <div class="header-block__desc">
                                    <span class="info_important">*</span>
                                    All information is encrypted using the strongest encryption technology available.
                                </div>
                            </div>

                            <!-- Accepted credit cards -->
                            <div class="payment-container mt-4">
                                <label class="form-label credit-card-label">Accepted credit cards</label>
                                <div class="credit-cards-list">
                                    <img *ngFor="let card of acceptedCreditCards" [src]="card.src" [alt]="card.alt">
                                </div>
                            </div>

                            <!-- Payment Card Input Wrapper (Stripe/PayPal/etc.) -->
                            <app-payment-card-input-wrapper
                                *ngIf="merchantPlatform"
                                [merchantPlatform]="merchantPlatform"
                                [showFormErrors]="showFormErrors">
                            </app-payment-card-input-wrapper>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="new-credit-card-main new-credit-card-main-bottom-header new-credit-card-buttons-container">
            <div class="new-credit-card-main-inner">
                <div class="new-credit-card-main-left">
                    <div class="new-credit-card-main-button">
                        <button type="button" class="save-button" id="saveCCInfoButton" (click)="onSubmit()">
                            <span>Save New Card Details</span>
                            <span>
                                <span class="icon-span" *ngIf="!showLoading">></span>
                                <div class="spinner" *ngIf="showLoading">
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                </div>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="new-credit-card-main-right"></div>
                <div id="loadingModal" class="progress-modal">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
    </div>

    <div id="successContainer" *ngIf="showSuccess">
        <div class="new-credit-card-main new-credit-card-main-top-header">
            <div class="new-credit-card-main-inner" style="grid-template-columns: auto;">
                <div class="new-credit-card-main-left">
                    <h4>
                        Credit card was successfully stored.<br/>
                        Please close this window to protect your privacy.
                    </h4>
                </div>
            </div>
        </div>
    </div>

</div>
